import { Component, Input } from '@angular/core';

import { JoinListPipe } from '../../../shared/pipes/join-list.pipe';

@Component({
    selector: 'app-client-task-history-item-rejected-prescriptions',
    templateUrl: './client-task-history-item-rejected-prescriptions.component.html',
    imports: [JoinListPipe]
})
export class ClientTaskHistoryItemRejectedPrescriptionsComponent {
  @Input() clientTaskHistoryItem;

  get rejectedPrescriptionIds() {
    const rejectedPrescriptionIds = this.clientTaskHistoryItem.data.rejectedPrescriptionIds;
    if (rejectedPrescriptionIds && rejectedPrescriptionIds.length > 0) {
      return rejectedPrescriptionIds;
    } else {
      return null;
    }
  }
}
